export function normalizeQuillHtml(html: string): string {
  if (!html) return html;

  const leadingWhitespace = "(?:\\s|&nbsp;|\\u00a0|&#160;|&#xA0;)+";

  return html
    .replace(new RegExp(`<li([^>]*)>${leadingWhitespace}`, "gi"), "<li$1>")
    .replace(new RegExp(`<li([^>]*)><p([^>]*)>${leadingWhitespace}`, "gi"), "<li$1><p$2>");
}
